import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ExpertEventNotificationRecord } from '@libs/shared/api';
import { ExpertEventNotificationWrapperComponent } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification-wrapper.component';
import { injectExpertEventNotificationService } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification.service';
import { ExpertMemberTitlePipe } from '@sprint-expert/app/utils/pipe/expert-member-title.pipe';

@Component({
  selector: 'app-member-workout-mission-checked-by-date-notification',
  standalone: true,
  imports: [
    CommonModule,
    ExpertEventNotificationWrapperComponent,
    ExpertMemberTitlePipe,
  ],
  template: `
    <app-expert-event-notification-wrapper
      class="cursor-pointer"
      (click)="onClick()"
      [notification]="notification"
      title="운동 숙제를 완료하셨어요!">
      <div class="text-secondary">
        <p>회원명: {{ notification.expertMember | expertMemberTitle }}</p>
      </div>
    </app-expert-event-notification-wrapper>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberWorkoutMissionCheckedByDateNotificationComponent {
  readonly vm = injectExpertEventNotificationService();
  readonly router = inject(Router);

  @Input({ required: true }) notification: ExpertEventNotificationRecord;

  onClick() {
    this.vm.readExpertEventNotification(this.notification);
    this.router.navigate(
      [
        'expert-workspace',
        this.vm.currentExpertWorkspace$$().id,
        'expert-member',
        this.notification.memberWorkoutMission.expertMemberId,
      ],
      {
        onSameUrlNavigation: 'reload',
      }
    );
  }
}
